import { getTaskStatus } from "@/services/api/tasks";
import type { SnapshotTaskStatus } from "@/services/api/data-hub/types";

const TERMINAL_STATUSES = new Set(["completed", "failed", "cancelled", "partial_failure"]);

export async function waitForCaseCheckTask(
  taskId: string,
  options?: { timeoutMs?: number; pollIntervalMs?: number },
): Promise<SnapshotTaskStatus> {
  const timeoutMs = options?.timeoutMs ?? 900_000;
  const pollIntervalMs = options?.pollIntervalMs ?? 2_000;
  const deadline = Date.now() + timeoutMs;

  while (Date.now() < deadline) {
    const status = await getTaskStatus(taskId);
    const normalized = (status.status || "").toLowerCase();
    if (TERMINAL_STATUSES.has(normalized)) {
      if (normalized === "failed" || normalized === "cancelled") {
        throw new Error(status.error || status.status_message || `Task ${taskId} ${normalized}`);
      }
      return status;
    }
    await new Promise((resolve) => setTimeout(resolve, pollIntervalMs));
  }

  throw new Error(`Task ${taskId} did not complete within ${timeoutMs}ms`);
}
